<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('code') }}</span>
                        <el-input
                            size="mini"
                            v-model="search.code"
                            :placeholder="$t('pleaseInputHint')"
                            clearable
                            @change="searchHandle">
                        </el-input>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('taskType') }}</span>
                        <el-select size="mini" v-model="search.type" clearable @change="searchHandle()">
                            <el-option v-for="item in typeOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('runState') }}</span>
                        <el-select size="mini" v-model="search.runState" clearable @change="searchHandle()">
                            <el-option v-for="item in stateOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('lastRunResult') }}</span>
                        <el-select size="mini" v-model="search.lastRunResult" clearable @change="searchHandle()">
                            <el-option v-for="item in lastRunResultOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('whetherEnable') }}</span>
                        <el-select size="mini" v-model="search.enabled" clearable @change="searchHandle()">
                            <el-option v-for="item in enabledOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="search-handle">
                    <el-button type="primary" size="mini" @click="searchHandle">{{ $t('search') }}</el-button>
                    <el-button type="primary" size="mini" @click="emptyHandle">{{ $t('empty') }}</el-button>
                    <el-button type="primary" size="mini" @click="addDialog = true" v-permission="['adve:task-create']">{{ $t('add') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column prop="code" align="center" :label="$t('code')" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" align="center" :label="$t('taskType')" :formatter="typeFormatter" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="params" align="center" :label="$t('runParam')" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cronExpression" align="center" label="cron" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="runState" align="center" :label="$t('runState')" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.runState === 100">{{ $t('notStart') }}</span>
                        <span v-else-if="scope.row.runState === 101">{{ $t('notRun') }}</span>
                        <span class="blue" v-else-if="scope.row.runState === 102">{{ $t('lineUp') }}</span>
                        <span class="blue" v-else-if="scope.row.runState === 103">{{ $t('running') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lastRunResult" align="center" :label="$t('lastRunResult')" :formatter="runResultFormatter" width="150"></el-table-column>
                <el-table-column prop="lastStartAt"
                                 align="center"
                                 :label="$t('lastRunTime1')"
                                 width="180"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.lastStartAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lastSuccessAt"
                                 align="center"
                                 :label="$t('lastRunTime2')"
                                 width="180"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.lastSuccessAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lastFailAt"
                                 align="center"
                                 :label="$t('lastRunTime3')"
                                 width="180"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.lastFailAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lastRunLog" align="center" :label="$t('lastRunLog')" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="enabled"
                                 align="center"
                                 :label="$t('whetherEnable')"
                                 width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.enabled">{{ $t('yes') }}</span>
                        <span v-else>{{ $t('no') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    fixed="right"
                    width="200">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="runTaskHandle(scope.row.id)"
                            v-if="scope.row.runState === 100 || scope.row.runState === 101"
                            v-permission="['adve:task-run']">{{ $t('run') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="editHandle(scope.row.id)"
                            v-permission="['adve:task-update']">{{ $t('edit') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="enableHandle(scope.row.id)"
                            v-if="!scope.row.enabled"
                            v-permission="['adve:task-update']">{{ $t('enable') }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            class="red"
                            @click="disenableHandle(scope.row.id)"
                            v-if="scope.row.enabled"
                            v-permission="['adve:task-update']">{{ $t('disenable') }}
                        </el-button>
                        <el-button
                            class="red"
                            type="text"
                            size="mini"
                            @click="deleteHandle(scope.row.id)"
                            v-permission="['adve:task-delete']">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="currentPage"
                layout="sizes, prev, pager, next, total"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 添加 -->
        <Add
            :parent-dialog="addDialog"
            @parent-update="getListData"
            @parent-close="addDialog = false"/>
        <!-- 编辑 -->
        <Edit
            :parent-dialog="editDialog"
            :parent-id="itemId"
            @parent-update="getListData"
            @parent-close="editDialog = false"/>
    </div>
</template>

<script>
import {queryAdvertTimedTaskList, runAdvertTimedTask, deleteAdvertTimedTask, enableAdvertTimedTask, disenableAdvertTimedTask} from "@/api/modules/api";
import Add from '@/components/advert/timed-task/Add'
import Edit from '@/components/advert/timed-task/Edit'
export default {
    name: "AdvertTimedTask",
    // 组件
    components: {
        Add,
        Edit
    },
    props: {},
    data() {
        return {
            search: {
                code: '',
                type: '',
                runState: '',
                lastRunResult: '',
                enabled: ''
            },
            typeOptions: [
                {
                    label: this.$t('advertCrawler'),
                    value: 101
                },
                {
                    label: this.$t('shopLogoRep'),
                    value: 102
                },
                {
                    label: this.$t('pdfTask'),
                    value: 103
                },
                {
                    label: this.$t('advertPaperRep'),
                    value: 104
                },
                {
                    label: this.$t('slicingRep'),
                    value: 105
                },
                {
                    label: this.$t('advertBookRep'),
                    value: 106
                },
                {
                    label: this.$t('merchantLogoRep'),
                    value: 107
                }
            ],
            stateOptions: [
                {
                    label: this.$t('notStart'),
                    value: 100
                },
                {
                    label: this.$t('notRun'),
                    value: 101
                },
                {
                    label: this.$t('lineUp'),
                    value: 102
                },
                {
                    label: this.$t('running'),
                    value: 103
                }
            ],
            lastRunResultOptions: [
                {
                    label: this.$t('succeed'),
                    value: 101
                },
                {
                    label: this.$t('error'),
                    value: 102
                },
            ],
            enabledOptions: [
                {
                    label: this.$t('yes'),
                    value: true
                },
                {
                    label: this.$t('no'),
                    value: false
                },
            ],
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
            addDialog: false,
            itemId: '',
            editDialog: false,
            paperDialog: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData() {
            const params = {
                code: this.search.code.trim(),
                type: this.search.type,
                runState: this.search.runState,
                lastRunResult: this.search.lastRunResult,
                enabled: this.search.enabled,
                page: this.currentPage,
                size: this.pageSize
            }
            queryAdvertTimedTaskList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                    // 检验是否列表为空
                    if (this.tableData.length === 0 && this.currentPage > 1) {
                        this.currentPage--
                        this.getListData()
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 格式化任务类型
        typeFormatter (row) {
            let type = row.type
            switch (type) {
                case 101:
                    return this.$t('advertCrawler')
                case 102:
                    return this.$t('shopLogoRep')
                case 103:
                    return this.$t('pdfTask')
                case 104:
                    return this.$t('advertPaperRep')
                case 105:
                    return this.$t('slicingRep')
                case 106:
                    return this.$t('advertBookRep')
                case 107:
                    return this.$t('merchantLogoRep')
                default:
                    return ''
            }
        },
        // 格式化上次运行结果
        runResultFormatter (row) {
            let result = row.lastRunResult
            switch (result) {
                case 101:
                    return this.$t('succeed')
                case 102:
                    return this.$t('error')
                default:
                    return ''
            }
        },
        // 清空
        emptyHandle () {
            this.search = {
                code: '',
                type: '',
                runState: '',
                lastRunResult: '',
                enabled: ''
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 运行
        runTaskHandle (id) {
            this.$confirm(this.$t('runTaskHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                runAdvertTimedTask(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        // 启用
        enableHandle (id) {
            this.$confirm(this.$t('enableTaskHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                enableAdvertTimedTask(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        // 禁用
        disenableHandle (id) {
            this.$confirm(this.$t('disenableTaskHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                disenableAdvertTimedTask(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteAdvertTimedTask(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
